import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux-stores/store'
import userDummyImg from "../../assets/images/user.png"
import "../../styles/_theme.scss"
import { useNavigate } from 'react-router-dom'
import useScrolledHeight from '../../hooks/useScrolledHeight'
import { Link } from 'react-router-dom'

const AppHeader = () => {
    const user = useSelector((state: RootState) => state.auth.user)
    const header = useSelector((state: RootState) => state.layout.header);
    const navigate = useNavigate();
    const unreadMsgsCount = useSelector((state: RootState) => state.chat.unreadCount);

    const scrolledHeight = useScrolledHeight();

    if (!header) return null;

    if (header.page) {
        return (
            <div className="app-header app-page-header bg-white">
                <div className="d-flex align-items-center gap-3 justify-content-between w-100">
                    <div className="d-flex align-items-center gap-3">
                        <span className='back-btn' onClick={() => {
                            if (header.page?.onBackClick) {
                                return header.page.onBackClick();
                            }
                            navigate(-1);
                        }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path fillRule="evenodd" clipRule="evenodd" d="M10.5303 5.46967C10.8232 5.76256 10.8232 6.23744 10.5303 6.53033L5.81066 11.25H20C20.4142 11.25 20.75 11.5858 20.75 12C20.75 12.4142 20.4142 12.75 20 12.75H5.81066L10.5303 17.4697C10.8232 17.7626 10.8232 18.2374 10.5303 18.5303C10.2374 18.8232 9.76256 18.8232 9.46967 18.5303L3.46967 12.5303C3.17678 12.2374 3.17678 11.7626 3.46967 11.4697L9.46967 5.46967C9.76256 5.17678 10.2374 5.17678 10.5303 5.46967Z" fill="#171717" />
                            </svg>
                        </span>
                        <span className="page-info text-truncate" style={{ width: header.page?.rightContent ? 'calc(100vw - 180px)' : 'calc(100vw - 100px)' }}>{header.page.title}</span>
                    </div>
                    {header.page.rightContent}
                </div>
            </div>
        )
    }

    return (
        <div className={`app-header w-100 justify-content-between align-items-center position-fixed z-1 ${scrolledHeight > 0 ? 'bg-white' : ''}`}>
            <div className='app-header-left'>
                <div className='profile-image'>
                    <Link to={{ pathname: '/i/me' }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M20.75 7C20.75 7.41421 20.4142 7.75 20 7.75L4 7.75C3.58579 7.75 3.25 7.41421 3.25 7C3.25 6.58579 3.58579 6.25 4 6.25L20 6.25C20.4142 6.25 20.75 6.58579 20.75 7Z" fill="#171717" />
                            <path fillRule="evenodd" clipRule="evenodd" d="M17.9844 12C17.9844 12.4142 17.7017 12.75 17.3529 12.75L3.88147 12.75C3.53272 12.75 3.25 12.4142 3.25 12C3.25 11.5858 3.53272 11.25 3.88147 11.25L17.3529 11.25C17.7017 11.25 17.9844 11.5858 17.9844 12Z" fill="#171717" />
                            <path fillRule="evenodd" clipRule="evenodd" d="M19.9941 17C19.9941 17.4142 19.6729 17.75 19.2765 17.75L3.96761 17.75C3.57128 17.75 3.25 17.4142 3.25 17C3.25 16.5858 3.57128 16.25 3.96761 16.25L19.2765 16.25C19.6729 16.25 19.9941 16.5858 19.9941 17Z" fill="#171717" />
                        </svg>
                    </Link>
                </div>
            </div>
            <div className='app-header-right'>
                <Link to={{ pathname: '/chat' }}>
                    {
                        (unreadMsgsCount > 0) ? (
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="32" height="32" rx="16" fill="white" />
                                <path d="M12.668 16H12.6755M15.9938 16H16.0013M19.3271 16H19.3346" stroke="#171717" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M15.9987 24.3334C20.6011 24.3334 24.332 20.6025 24.332 16.0001C24.332 11.3977 20.6011 7.66675 15.9987 7.66675C11.3963 7.66675 7.66536 11.3977 7.66536 16.0001C7.66536 17.3331 7.97838 18.5931 8.53492 19.7105C8.68281 20.0074 8.73204 20.3468 8.6463 20.6673L8.14996 22.5223C7.93449 23.3276 8.67121 24.0643 9.47649 23.8488L11.3315 23.3525C11.652 23.2667 11.9914 23.316 12.2883 23.4639C13.4057 24.0204 14.6656 24.3334 15.9987 24.3334Z" stroke="#171717" strokeWidth="1.25" />
                                <circle cx="22.5" cy="9.5" r="4" fill="#5DD27A" stroke="white" />
                            </svg>
                        ) : (
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M6.66602 10H6.67352M9.99185 10H9.99935M13.3252 10H13.3327" stroke="#171717" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M10.0007 18.3333C14.603 18.3333 18.334 14.6024 18.334 9.99999C18.334 5.39762 14.603 1.66666 10.0007 1.66666C5.39828 1.66666 1.66732 5.39762 1.66732 9.99999C1.66732 11.3331 1.98033 12.593 2.53687 13.7104C2.68477 14.0073 2.73399 14.3467 2.64825 14.6672L2.15191 16.5222C1.93645 17.3275 2.67316 18.0642 3.47844 17.8487L5.33347 17.3524C5.65393 17.2666 5.99332 17.3159 6.29026 17.4638C7.40762 18.0203 8.66758 18.3333 10.0007 18.3333Z" stroke="#171717" strokeWidth="1.25" />
                            </svg>
                        )
                    }
                </Link>
            </div>
        </div>
    )
}

export default AppHeader